/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Client, RequestContext } from "../client";
import type { NamedReferenceItem, PaginatedCollection, ResourceCollection } from "../resources";
import type { ListArgs } from "./basicRepository";
import { MixedScopeBaseRepository } from "./mixedScopeBaseRepository";
// Provider IDs for approvals
//export type ApprovalProviderId = "octopus" | "servicenow" | "jsm" | "all";
// Status types for approvals
//export type ServerTaskApprovalStatus = "pending" | "approved" | "rejected" | undefined;
export type ChangeRequestApprovalState = "preapproval" | "approved" | "postapproval";
// Server Task Approval Resource
export interface ServerTaskApprovalResource {
    Id: string;
    ServerTaskId: string;
    SpaceId: string;
    Name: string;
    ApprovalProviderId?: string;
    Status: ChangeRequestApprovalState;
    ChangeRequest: ChangeRequestResource;
    Links: {
        Self: string;
        Task: string;
    };
}
export interface ServerTaskApprovalsBffResponse {
    ServerTaskApprovals: PaginatedCollection<ServerTaskApprovalBffResponse>;
}
export interface ServerTaskApprovalBffResponse {
    Id: string;
    SpaceId: string;
    Environment: NamedReferenceItem;
    Project: NamedReferenceItem;
    Task: NamedReferenceItem;
    Approvals: Approval[];
    Approvers: NamedReferenceItem[];
    ExecutionState: string;
    ApprovalState: "preapproval" | "approved" | "postapproval";
    ApprovalsCount: number;
    MinimumApproversRequired: number;
    IsExternal: boolean;
    ExternalLink: string;
    ExternalNumber: string;
}
interface Approval {
    State: "Approved" | "Rejected";
    UserId: string;
    Username: string;
    Comment: string;
    Date: string;
}
export interface ChangeRequestResource {
    Id: string;
    Number: string;
    Description: string;
    Active: boolean;
    Type: string;
    ChangeRequestApprovalState: ChangeRequestApprovalState;
    Self: string;
}
export interface ServerTaskApprovalCounts {
    Approved: number;
    PreApproval: number;
    PostApproval: number;
}
export interface ServerTaskApprovalResourceCollection extends ResourceCollection<ServerTaskApprovalResource> {
}
export interface ServerTaskApprovalListArgs extends ListArgs {
    providerId?: string;
    state?: ChangeRequestApprovalState;
    spaces?: string[];
}
export class ServerTaskApprovalRepository extends MixedScopeBaseRepository<ServerTaskApprovalResource, never, ServerTaskApprovalListArgs> {
    constructor(client: Client, requestContext: RequestContext) {
        super("ServerTaskApprovals", client, requestContext);
    }
    async list(args?: ServerTaskApprovalListArgs): Promise<ServerTaskApprovalResourceCollection> {
        const combinedParameters = this.extend(this.spacePartitionParameters(), args);
        return await this.client.get<ServerTaskApprovalResourceCollection>(this.requestContext, "~/api/{spaceId}/servertaskapprovals{?skip,take,providerId,state,spaces}", combinedParameters);
    }
    async listBff(args?: ServerTaskApprovalListArgs): Promise<ServerTaskApprovalsBffResponse> {
        const combinedParameters = this.extend(this.spacePartitionParameters(), args);
        return await this.client.get<ServerTaskApprovalsBffResponse>(this.requestContext, "~/bff/spaces/{spaceId}/servertaskapprovals{?skip,take,providerId,state,spaces}", combinedParameters);
    }
    async get(id: string, args?: any): Promise<ServerTaskApprovalResource> {
        const allArgs = this.extend(args || {}, { id });
        const argsWithSpace = this.extend(this.spacePartitionParameters(), allArgs);
        return this.client.get<ServerTaskApprovalResource>(this.requestContext, "~/api/{spaceId}/servertaskapprovals/{id}", argsWithSpace);
    }
    async countsBff(providerId?: string): Promise<ServerTaskApprovalCounts> {
        return this.client.get<ServerTaskApprovalCounts>(this.requestContext, "~/bff/spaces/{spaceId}/servertaskapprovals/counts{?providerId}", { providerId });
    }
}
